import { createApp } from "vue";
import { createPinia } from 'pinia'
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import "@/core/plugins/keenthemes";
import "@/core/plugins/prismjs";
import "bootstrap";
import mitt from 'mitt';
import * as dayjs from 'dayjs'
import 'dayjs/locale/pt-br'; // import locale
import Maska from 'maska';
import money from 'v-money';
import { useConfigConcessionariaStore } from "./pinia/concessionaria/useConfigConcessionariaStore";

dayjs.locale('pt-br')

const pinia = createPinia();
const emitter = mitt();
const app = createApp(App);
app.use(pinia)

app.directive('cancelreadonly', (el) => {
    const input = el.querySelector('.el-input__inner');
    if (input) {
        input.removeAttribute('readonly');
    }
});

app.config.globalProperties.emitter = emitter;

app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(money);
app.use(Maska);
ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);
app.mount("#app");

const codConcessionaria = window.localStorage.getItem('filtroConcessionaria')
if (codConcessionaria) {
    const concessionariaStore = useConfigConcessionariaStore()
    concessionariaStore.setConfigConcessionaria(Number(codConcessionaria))
}

const originalSetItem = localStorage.setItem;

localStorage.setItem = function (key, value) {
  // dispara evento customizado
  window.dispatchEvent(new CustomEvent("localstorage-change", { detail: { key, value } }));

  // chama o setItem original
  return originalSetItem.apply(this, [key, value]);
};

window.addEventListener("localstorage-change", (event: any) => {
    console.log('filtroConcessionaria')
  if (event.detail.key === "filtroConcessionaria") {
    const concessionariaStore = useConfigConcessionariaStore();
    concessionariaStore.setConfigConcessionaria(Number(event.detail.value));
  }
});